import {Chip} from 'platform/components';
import {HStack} from 'platform/foundation';

import {includes} from 'ramda';

import {VehicleFinancingTerm} from '@dms/api/sales';

import {RequiredTestIdProps, suffixTestId} from 'shared/web';

import {RATE_MATRIX_TERMS} from '../constants/RATE_MATRIX_TERMS';

interface RateMatrixTermPillsProps extends RequiredTestIdProps {
  availableTerms: VehicleFinancingTerm[];
  isReadOnly: boolean;
  onToggleTerm: (term: VehicleFinancingTerm) => void;
}

export function RateMatrixTermPills(props: RateMatrixTermPillsProps) {
  return (
    <HStack spacing={2} wrap>
      {RATE_MATRIX_TERMS.map((term) => (
        <Chip
          key={term}
          label={term.toString()}
          value={includes(term, props.availableTerms)}
          isDisabled={props.isReadOnly}
          onChange={() => props.onToggleTerm(term)}
          tabIndex={props.isReadOnly ? -1 : 0}
          data-testid={suffixTestId(`term-[${term}]`, props)}
        />
      ))}
    </HStack>
  );
}
